module.exports = __webpack_public_path__ + "static/media/1856.87b5cb7d.jpg";